var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlideView',{attrs:{"validation-mode":"","with-annotations":"","with-annotation-details":"","float-mode":_vm.floatMode},on:{"float-mode:changed":function($event){_vm.floatMode = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }